import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.VUE_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.VUE_APP_SUPABASE_ANON_KEY;

// The Vuex auth store is the single owner of the session: tokens live in
// `authUser` and are rotated only through the backend's /auth/refresh.
// supabase-js is used for the OAuth handshake alone — it must not keep or
// auto-refresh its own copy. Two refreshers on one Supabase token family
// trip refresh-token reuse detection, which revokes the whole family and
// force-logs-out the user on every timing divergence (sleep/wake, tab switch).
const supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
        autoRefreshToken: false,
        persistSession: false,
    },
});

// Older app versions let supabase-js persist its own session copy. A leftover
// copy replayed by an old tab still revokes the live session — remove it.
// Safe on the OAuth callback page: the implicit-flow session arrives in the
// URL fragment, not in these storage keys.
try {
    Object.keys(localStorage)
        .filter((key) => key.startsWith('sb-') && key.includes('-auth-token'))
        .forEach((key) => localStorage.removeItem(key));
} catch (e) {
    // localStorage unavailable — nothing to clean
}

export default supabase;
